import React, { Component } from 'react';
import AutoComplete from 'material-ui/AutoComplete/index';

class FormAutoComplete extends Component {
    handleUpdateInput = value => {
        const { name, onChange } = this.props;

        onChange(name, value);
    };

    render() {
        const { name, onChange, required, ...props } = this.props;

        return <AutoComplete onUpdateInput={this.handleUpdateInput} {...props} />;
    }
}

export default FormAutoComplete;



// WEBPACK FOOTER //
// ./src/UI/FormAutoComplete.js